import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appResidential]'
})
export class ResidentialDirective {

  constructor(public viewContainerRef: ViewContainerRef) { }

}
